import React, { useState, useEffect } from "react";
import { Table } from "antd";

const TesterOtpTable = ({ testerId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!testerId) {
        setLoading(false);
        setHasFetched(true);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(
          `https://gj2fi00268.execute-api.us-east-1.amazonaws.com/dev/testerwise-banned-app-otp-count/${testerId}`
        );
        if (!response.ok) throw new Error("Failed to fetch data");
        const result = await response.json();
        setData(Array.isArray(result) && result.length > 0 ? result : []);
      } catch (err) {
        setError(err.message);
        setData([]);
      } finally {
        setLoading(false);
        setHasFetched(true);
      }
    };

    fetchData();
  }, [testerId]);

  const columns = [
    { title: "Sender ID", dataIndex: "sender_id", key: "sender_id" },
    { title: "Count", dataIndex: "count(*)", key: "count" },
  ];

  const isEmpty = hasFetched && !loading && (!data || data.length === 0);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="banned-otp-table-error">Error: {error}</p>;
  if (isEmpty) return <p className="banned-otp-table-empty">No data available for this tester.</p>;

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey={(record, index) => index}
      locale={{ emptyText: "No data" }}
    />
  );
};

export default TesterOtpTable;
